// Blocks authenticated site use until required legal policies are accepted.

import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LegalAcceptanceRequiredModal } from './LegalAcceptanceRequiredModal';
import './LegalAcceptanceRequiredModal.css';

export function LegalAcceptanceGate({ children }) {
  const location = useLocation();
  const {
    isAuthenticated,
    loading,
    legalAcceptance,
    legalAcceptanceComplete,
    acceptLegalDocuments,
    logout,
  } = useAuth();
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const authExemptPath = location.pathname.startsWith('/auth');
  const showGate =
    isAuthenticated &&
    !loading &&
    !legalAcceptanceComplete &&
    !authExemptPath;

  const handleAccept = async ({ slugs }) => {
    setSubmitting(true);
    setError('');
    try {
      await acceptLegalDocuments({ slugs });
    } catch (e) {
      setError(e?.message || 'Could not save acceptance. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      {children}
      {showGate && (
        <>
          <div className="legal-acceptance-backdrop" aria-hidden />
          <LegalAcceptanceRequiredModal
            isOpen
            legalAcceptance={legalAcceptance}
            onAccept={handleAccept}
            onLogout={logout}
            submitting={submitting}
            error={error}
          />
        </>
      )}
    </>
  );
}
